/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Box, Button, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import TeamDocumentModal from "../../Modals/teamDocument";

const TeamList = () => {

    const navigate = useNavigate();

    const label = { inputProps: { 'aria-label': 'Switch demo' } };

    const rows = [
        {
            id: 1,
            profession: "Profession 1",
            ongoingJobs: "5",
            completedJobs: "5"
        },
        {
            id: 2,
            profession: "Profession 1",
            ongoingJobs: "5",
            completedJobs: "5"
        },
        {
            id: 3,
            profession: "Profession 1",
            ongoingJobs: "5",
            completedJobs: "5"
        },
        {
            id: 4,
            profession: "Profession 1",
            ongoingJobs: "5",
            completedJobs: "5"
        },
        {
            id: 5,
            profession: "Profession 1",
            ongoingJobs: "5",
            completedJobs: "5"
        },
    ];
    const columns: GridColDef<(typeof rows)[number]>[] = [
        {
            flex: 1,
            minWidth: 240,
            field: "name",
            headerName: "Team Name",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="user_block click_action" onClick={() => navigate("/manage-maintenance-team/detail")}>
                        <figure>
                            <img src="/static/images/user_placeholder.png" alt="" />
                        </figure>
                        <p><b>Maintenance Team 1</b> <span>maintenance@gmail.com</span></p>
                    </div>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: "profession",
            headerName: "Profession/Skills",
            editable: false,
            sortable: false,
        },
        {
            minWidth: 150,
            field: "ongoingJobs",
            headerName: "Ongoing Jobs",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            minWidth: 150,
            field: "completedJobs",
            headerName: "Completed Jobs",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            minWidth: 130,
            field: "document",
            headerName: "Document",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                    <Button className="btn sm btn_primary" onClick={() => setOpen(true)}>View</Button>
                )
            }
        },
        {
            minWidth: 150,
            field: "earnings",
            headerName: "Total Earnings",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                    <p className="c_success"><strong>AED 2000</strong></p>
                )
            }
        },
        {
            minWidth: 100,
            field: "status",
            headerName: "Status",
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                    <Switch {...label} />
                )
            }
        },
        {
            minWidth: 130,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: () => {
                return (
                    <div className="table_actions v2">
                        <Box>
                            <IconButton onClick={() => navigate("/manage-maintenance-team/detail")}>
                                <img src="/static/images/eye_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton onClick={() => navigate("/manage-maintenance-team/add")}>
                                <img src="/static/images/edit2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                        <Box>
                            <IconButton>
                                <img src="/static/images/trash2_icon.svg" alt="" />
                            </IconButton>
                        </Box>
                    </div>
                )
            }
        }
    ];
    let hidden = ["fullName"];
  
    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
      setOpen(false);
    };

    return (
        <>
            <div className="sorting_table">
                <TableComponent
                    columns={columns?.filter((item) => !hidden.includes(item.field))}
                    rows={rows}
                />
            </div>

            <TeamDocumentModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
        </>
    );
};

export default TeamList;
